import { FormData, IMarketingConsents } from "../types";

const formatNumber = (value: string) => {
  try {
    return Number(value.replace(/,/g, ""));
  } catch (e) {
    return value;
  }
}

const submitData = async (body: string) => {
  const res = await fetch(`${PUBLIC_API_HOST}/v1/crm/contact`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body,
    credentials: "include"
  });

  if (res.status === 200 || res.status === 201) {
    return;
  }

  throw new Error("Failed to submit data. Please try again later.");
};

export const submitPurchaseData = async (
  firstName: string,
  email: string,
  consents: IMarketingConsents,
  data: FormData,
  referrer?: string
) =>
  submitData(
    JSON.stringify({
      firstName,
      email,
      consents,
      mortgagePurpose: data.mortgagePurpose,
      propertyValue: formatNumber(data.propertyValue!),
      borrowAmount: formatNumber(data.borrowAmount!),
      combinedIncome: formatNumber(data.combinedIncome!),
      homeBuyingStage: data.homeBuyingStage,
      deposit: formatNumber(data.deposit!),
      nextSteps: data.nextSteps,
      ...(referrer && { referrer }),
    })
  );

export const submitRemoData = async (
  firstName: string,
  email: string,
  consents: IMarketingConsents,
  data: FormData,
  referrer?: string
) =>
  submitData(
    JSON.stringify({
      firstName,
      email,
      consents,
      mortgagePurpose: data.mortgagePurpose,
      propertyValue: formatNumber(data.propertyValue!),
      dealExpiry: data.dealExpiry,
      additionalBorrowing: data.additionalBorrowing,
      balance: formatNumber(data.balance!),
      ...(referrer && { referrer }),
    })
  );
